import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BulkTaxReportRoutingModule } from './bulk-tax-report-routing.module';
import {FormsModule} from "@angular/forms";
import {CalendarModule} from "primeng/calendar";
import {CheckboxModule} from "primeng/checkbox";
import {AutoCompleteModule} from "primeng/autocomplete";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GrowlModule} from "primeng/growl";
import {CoreModule} from "../../core/core.module";
import {TableModule} from "primeng/table";
import {TranslateModule} from "@ngx-translate/core";
import {BulkTaxReportComponent} from "./bulk-tax-report.component";
import {DropdownModule} from "primeng/dropdown";

@NgModule({
  imports: [
    CommonModule,
    // BulkTaxReportRoutingModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule,
    TranslateModule,
    DropdownModule
  ],
  declarations: [BulkTaxReportComponent]
})
export class BulkTaxReportModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report.module.ts